import Coin from './Coin';
// import EmailSub from './EmailSub';
import EmailSubscription from './EmailSubscription';
import Notice from './Notice';
import Recharge from './Recharge';
import Transaction from './Transaction';
const globalLangList = [
  {
    value: 'en',
    label: 'English',
  },
  {
    value: 'zh-MY',
    label: '简体中文 (马来西亚)',
  },
  {
    value: 'zh-TW',
    label: '繁體中文',
  },
  // {
  //   value: 'zh-HK',
  //   label: '繁體中文 (香港)',
  // },
  {
    value: 'ja-JP',
    label: '日本語',
  },
  // {
  //   value: 'ko-KR',
  //   label: '한국어',
  // },
  {
    value: 'ru-RU',
    label: 'Русский',
  },
  {
    value: 'es-ES',
    label: 'Español(Internacional)',
  },
  // {
  //   value: 'tr-TR',
  //   label: 'Türkçe',
  // },
  {
    value: 'vi-VN',
    label: 'Tiếng Việt',
  },
  // {
  //   value: 'tr-TR',
  //   label: 'Türkçe',
  // },
  // {
  //   value: 'pt-BR',
  //   label: 'Português',
  // },
  {
    value: 'pt-BR',
    label: 'Português(Brasil)',
  },
  {
    value: 'pt-PT',
    label: 'Português(Internacional)',
  },
  // {
  //   value: 'fr-FR',
  //   label: 'Français',
  // },
  {
    value: 'th-TH',
    label: 'ไทย',
  },
  {
    value: 'id-ID',
    label: 'Bahasa Indonesia',
  },
  {
    value: 'uk-UA',
    label: 'Українська',
  },
  {
    value: 'kk-KZ',
    label: 'қазақша',
  },
  // {
  //   value: 'hi-IN',
  //   label: 'हिंदी',
  // },
  {
    value: 'fil-PH',
    label: 'Filipino',
  },
  {
    value: 'es-MX',
    label: 'Español(Mexico)',
  },
  {
    value: 'es-AR',
    label: 'Español(Argentina)',
  },
  // {
  //   value: 'es-419',
  //   label: 'Español Latinoamérica',
  // },
  {
    value: 'ar-SA',
    label: 'اللغة العربية',
  },
  {
    value: 'nl-NL',
    label: 'English(Netherlands)',
  },
];
const hkLangList = [
  {
    value: 'en-HK',
    label: 'English (Hong Kong)',
  },
  {
    value: 'zh-HK',
    label: '繁体中文（香港）',
  },
];
const nldLangList = [
  {
    label: 'English (Netherlands)',
    value: 'en-NL',
  },
  {
    label: 'Dutch',
    value: 'nl-NL',
  },
];

const trLangList = [
  {
    label: 'English(Turkey)',
    value: 'en-TR',
  },
  {
    label: 'Türkçe',
    value: 'tr-TUR',
  },
];

const kazLangList = [
  {
    label: 'Қазақша (Қазақстан)',

    value: 'kk-KAZ',
  },
  {
    label: 'Русский (Казахстан)',
    value: 'ru-KAZ',
  },
  {
    label: 'English (Kazakhstan)',
    value: 'en-KAZ',
  },
];

const eueLangList = [
  { label: 'English (Europe)', value: 'en-EU' },
  { label: 'Polski', value: 'pl-POL' },
  { label: 'Românǎ', value: 'ro-ROU' },
  { label: 'Español (España)', value: 'es-ESP' },
  { label: 'Português (Portugal)', value: 'pt-PRT' },
];

const langList = {
  COMMON: globalLangList,
  HKG: hkLangList,
  NLD: nldLangList,
  TUR: trLangList,
  KAZ: kazLangList,
  EU: eueLangList,
};

export interface IErrorType {
  ret_code: number;
  ret_msg: string;
  ext_info: string;
  ext_code: string | number;
  message?: string;
}

export {
  Coin,
  // EmailSub,
  EmailSubscription,
  langList,
  Notice,
  Recharge,
  Transaction,
};
